import styled, { css } from 'styled-components';
import { withQuery } from '@panel/commons/core/themev2';

const ChartsBelowSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ device }) => (device === 'tablet' ? 24 : 40)}px;
  ${({ device }) =>
    device === 'mobile' &&
    css`
      flex-direction: column;
      gap: 0;
    `}
  ${({ isDesktop }) =>
    isDesktop &&
    css`
      ${withQuery.xl.down()} {
        gap: 20px;
      }
    `}
`;

export { ChartsBelowSection };
